<template>
  <component :is="tag" class="fmhind-button" :class="`fmhind-button--${color}`">
    {{ text }}
  </component>
</template>

<script>
export default {
  name: 'Button',
  props: {
    link: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: 'primary',
      validator: prop => ['primary', 'secondary'].includes(prop)
    }
  },
  computed: {
    tag() {
      return this.link ? 'a' : 'button';
    }
  }
};
</script>

<style lang="scss">
.fmhind-button {
  @extend %text-lg;
  padding: $padding-md $padding-lg;
  transition: background-color 0.3s ease-in-out;

  &--primary {
    background: white;
    border: 1px solid $color-primary;
    color: $color-primary;
  }

  &--secondary {
    background: $color-secondary;
    color: white;
    border: 1px solid $color-secondary;
  }
}
</style>
